import React from 'react';
import PropTypes from 'prop-types';

import styles from './RacingThemeSearchFilterHeader.module.css';

/**
 * Search filter panel header.
 */
const RacingThemeSearchFilterHeader = props => {
  const { onClearAll } = props;

  return (
    <div className={styles.filterHeader}>
      <p className={styles.filterHeaderTitle}>Filters</p>
      <button type="button" className={styles.filterClearBtn} onClick={onClearAll}>
        Clear All
      </button>
    </div>
  );
};

RacingThemeSearchFilterHeader.propTypes = {
  onClearAll: PropTypes.func,
};

export default RacingThemeSearchFilterHeader;
